
import {
  Component, PropSync, Prop, Ref, Watch, Mixins,
} from 'vue-property-decorator';
import { InputValidationRules } from 'vuetify';
import {
  AddStorePayload,
  AddStorePayloadInputField,
  PlatformType,
  SupportedIntegration,
  SupportedIntegrationInputField,
} from '@/features/ecommerce/types';
import { requiredRules, charactersLimitRules } from '@/features/common/helpers/validationRules';
import { VForm } from '@/features/common/types';
import focusMixin from '@/features/common/mixins/focusMixin';

@Component
export default class AddStoreModal extends Mixins(focusMixin) {
  @PropSync('show', { required: true }) syncedShow!: boolean;

  @Prop({ required: true }) supportedStores!: SupportedIntegration[];

  @Prop({ default: false }) loading!: boolean;

  @Ref('form') form!: VForm;

  private selectedPlatform: PlatformType | '' = '';

  private fieldValues: { [key: string]: string } = {};

  private requiredRules = requiredRules;

  private charactersLimitRules = charactersLimitRules;

  get platforms(): string[] {
    return this.supportedStores?.map(({ platformType }) => platformType);
  }

  get platformDisclaimer(): string {
    switch (this.selectedPlatform) {
      case PlatformType.Etsy: return this.$t('eCommerce.storeDisclaimers.etsy') as string;
      default: return '';
    }
  }

  get fields(): SupportedIntegrationInputField[] {
    return this.supportedStores
      ?.find(({ platformType }) => platformType === this.selectedPlatform)?.inputFields
      || [];
  }

  @Watch('syncedShow')
  private resetValues(newVal) {
    if (!newVal) {
      (this.$refs.form as HTMLFormElement).resetValidation();
      this.selectedPlatform = '';
      this.fieldValues = {};
    }
  }

  private getFieldRules = (fieldId: string, required: boolean): InputValidationRules => {
    if (fieldId === 'DisplayName' && required) return [...this.requiredRules, ...this.charactersLimitRules(40)];
    if (fieldId === 'DisplayName') return this.charactersLimitRules(40);
    return required ? this.requiredRules : [];
  }

  private submit(): void {
    const isValid = this.form.validate();

    if (!isValid) return;

    const inputFields: AddStorePayloadInputField[] = this.supportedStores
      .find(({ platformType }) => platformType === this.selectedPlatform)?.inputFields
      .map((field) => ({
        fieldId: field.fieldId,
        value: this.fieldValues[field.fieldId],
      })) as AddStorePayloadInputField[];

    const payload: AddStorePayload = {
      platformType: this.selectedPlatform as PlatformType,
      inputFields,
    };

    this.$emit('addStore', payload);
  }
}
